// On-demand Google Fonts loading for non-Latin scripts.
// Latin visitors never download these; a script's font set loads once,
// the first time a language using that script is selected/detected.

const SCRIPT_FONTS = {
  cyrillic:
    "https://fonts.googleapis.com/css2?family=Noto+Serif:wght@400;500;600&family=Noto+Sans:wght@400;500&family=Noto+Sans+Mono:wght@400;500&display=swap",
  greek:
    "https://fonts.googleapis.com/css2?family=Noto+Serif:wght@400;500;600&family=Noto+Sans:wght@400;500&family=Noto+Sans+Mono:wght@400;500&display=swap",
  "cjk-sc":
    "https://fonts.googleapis.com/css2?family=Noto+Serif+SC:wght@400;500;600&family=Noto+Sans+SC:wght@400;500&display=swap",
  "cjk-tc":
    "https://fonts.googleapis.com/css2?family=Noto+Serif+TC:wght@400;500;600&family=Noto+Sans+TC:wght@400;500&display=swap",
  "cjk-jp":
    "https://fonts.googleapis.com/css2?family=Noto+Serif+JP:wght@400;500;600&family=Noto+Sans+JP:wght@400;500&display=swap",
  "cjk-kr":
    "https://fonts.googleapis.com/css2?family=Noto+Serif+KR:wght@400;500;600&family=Noto+Sans+KR:wght@400;500&display=swap",
  thai:
    "https://fonts.googleapis.com/css2?family=Noto+Serif+Thai:wght@400;500;600&family=Noto+Sans+Thai:wght@400;500&display=swap",
  georgian:
    "https://fonts.googleapis.com/css2?family=Noto+Serif+Georgian:wght@400;500;600&family=Noto+Sans+Georgian:wght@400;500&display=swap",
  arabic:
    "https://fonts.googleapis.com/css2?family=Noto+Naskh+Arabic:wght@400;500;600&family=Noto+Sans+Arabic:wght@400;500&display=swap",
};

const loaded = new Set();

export function ensureScriptFont(script) {
  if (typeof document === "undefined") return;
  const href = SCRIPT_FONTS[script];
  if (!href || loaded.has(script)) return;
  loaded.add(script);
  const link = document.createElement("link");
  link.rel = "stylesheet";
  link.href = href;
  link.setAttribute("data-script-font", script);
  document.head.appendChild(link);
}
